"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StyledTableHeaderCell = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ty = _interopRequireDefault(require("../../../framework/ty"));

var _templateObject;

var _default = {};
exports["default"] = _default;

var StyledTableHeaderCell = _styledComponents["default"].th.withConfig({
  displayName: "TableHeaderCellstyles__StyledTableHeaderCell",
  componentId: "sc-7vhtn-0"
})(["", ""], (0, _ty["default"])(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n    tl\n  ", "\n"])), function (_ref) {
  var _tableSize$size;

  var _ref$theme$table = _ref.theme.table,
      headerCell = _ref$theme$table.headerCell,
      tableSize = _ref$theme$table.size,
      size = _ref.size;
  return "\n    ".concat((_tableSize$size = tableSize[size]) === null || _tableSize$size === void 0 ? void 0 : _tableSize$size.headerCellSize, "\n    ").concat(headerCell, "\n  ");
}));

exports.StyledTableHeaderCell = StyledTableHeaderCell;